module.exports = __webpack_public_path__ + "img/dashboard.a003c176.svg";